import type { FeatureShellPorts } from '@src/core/bootstrap/FeatureShellPorts.ts';
import { clearSnapshotRevisionUpgradePending, isSnapshotRevisionUpgradePending } from '@src/modules/shared/local-sqlite/infrastructure/snapshotRevisionGuard.ts';

/**
 * After login/shell mount: remind operators when a bundle revision upgrade still needs catalog sync or has pending uploads.
 */
export function notifyPostSnapshotRevisionUpgrade(shellPorts: FeatureShellPorts): void {
  if (!isSnapshotRevisionUpgradePending()) return;

  const { puntosEntrega: pePending, redenciones: rbPending } = shellPorts.offlineSync.getExportRecordCounts();
  const hasPendingUpload = pePending > 0 || rbPending > 0;

  if (hasPendingUpload) {
    shellPorts.notifications.warning(
      `Actualización de la app: se conservaron los datos locales (${pePending} punto(s) de entrega y ${rbPending} redención(es) pendientes de envío). Sincronice catálogos y envíe registros cuando haya red.`,
    );
  } else {
    shellPorts.notifications.info(
      'Actualización de la app: sincronice catálogos en la pantalla Sync para cargar puntos de entrega del servidor.',
    );
  }
}

/** Clears the post-upgrade flag after a successful catalog download at startup or manual sync. */
export function acknowledgeSnapshotRevisionCatalogRefresh(): void {
  clearSnapshotRevisionUpgradePending();
}
